import { useEffect,useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import { useAppTheme } from "../../../context/ThemeContext";

export default function AdministratorsTable({
  administrators,
  loading,
  onEdit,
}){
  const {colors,typography}=useAppTheme();
  const [page,setPage]=useState(0);
  const [rowsPerPage,setRowsPerPage]=useState(10);

  useEffect(()=>{
    const maxPage=Math.max(0,Math.ceil(administrators.length/rowsPerPage)-1);
    if(page>maxPage) setPage(maxPage);
  },[administrators.length,rowsPerPage,page]);

  const rows=administrators.slice(
    page*rowsPerPage,
    page*rowsPerPage+rowsPerPage
  );

  return (
    <Box
      sx={{
        width:"100%",
        border:`1px solid ${colors.border}`,
        borderRadius:"12px",
        overflow:"hidden",
        backgroundColor:colors.surface,
      }}
    >
      <TableContainer sx={{overflowX:"auto"}}>
        <Table sx={{minWidth:900}}>
          <TableHead
            sx={{
              "& .MuiTableCell-root":{
                backgroundColor:colors.secondary,
                color:colors.tableHeaderText,
                borderBottom:`1px solid ${colors.secondary}`,
                fontWeight:typography.weights.bold,
              },
            }}
          >
            <TableRow>
              <TableCell>Administrador</TableCell>
              <TableCell>Identificación</TableCell>
              <TableCell>Correo</TableCell>
              <TableCell>Teléfono</TableCell>
              <TableCell>Estado</TableCell>
              <TableCell align="right">Acción</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loading&&(
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{py:5}}>
                  <CircularProgress size={24} color="secondary" />
                </TableCell>
              </TableRow>
            )}

            {!loading&&!rows.length&&(
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{py:5}}>
                  <Typography
                    sx={{
                      color:colors.textSecondary,
                      fontSize:typography.sizes.md,
                    }}
                  >
                    No hay administradores registrados.
                  </Typography>
                </TableCell>
              </TableRow>
            )}

            {!loading&&rows.map((administrator)=>(
              <TableRow
                key={administrator.id}
                sx={{
                  "&:last-child td":{borderBottom:0},
                  "&:hover":{
                    backgroundColor:colors.backgroundSoft,
                  },
                }}
              >
                <TableCell>
                  <Typography
                    sx={{
                      fontWeight:typography.weights.bold,
                      color:colors.text,
                      fontSize:typography.sizes.md,
                    }}
                  >
                    {administrator.nombre_completo||
                      `${administrator.nombres||""} ${administrator.apellidos||""}`.trim()||
                      "—"}
                  </Typography>
                </TableCell>

                <TableCell
                  sx={{
                    color:colors.textSecondary,
                    fontSize:typography.sizes.md,
                    whiteSpace:"nowrap",
                  }}
                >
                  {administrator.identificacion||"—"}
                </TableCell>

                <TableCell
                  sx={{
                    color:colors.textSecondary,
                    fontSize:typography.sizes.md,
                  }}
                >
                  {administrator.correo}
                </TableCell>

                <TableCell
                  sx={{
                    color:colors.textSecondary,
                    fontSize:typography.sizes.md,
                    whiteSpace:"nowrap",
                  }}
                >
                  {administrator.telefono||"—"}
                </TableCell>

                <TableCell>
                  <Typography
                    sx={{
                      fontWeight:typography.weights.semibold,
                      color:colors.text,
                      fontSize:typography.sizes.md,
                    }}
                  >
                    {administrator.is_active?"Activo":"Inactivo"}
                  </Typography>
                </TableCell>

                <TableCell align="right">
                  <Button
                    variant="outlined"
                    onClick={()=>onEdit(administrator)}
                    sx={{
                      borderColor:colors.borderDark,
                      color:colors.text,
                      "&:hover":{
                        borderColor:colors.secondary,
                        color:colors.secondary,
                        backgroundColor:colors.backgroundSoft,
                      },
                    }}
                  >
                    Editar
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={administrators.length}
        page={page}
        onPageChange={(event,newPage)=>setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(event)=>{
          setRowsPerPage(parseInt(event.target.value,10));
          setPage(0);
        }}
        rowsPerPageOptions={[5,10,25]}
        labelRowsPerPage="Filas:"
        labelDisplayedRows={({from,to,count})=>`${from}-${to} de ${count}`}
        sx={{
          color:colors.textSecondary,
          backgroundColor:colors.surface,
          borderTop:`1px solid ${colors.border}`,
          ".MuiTablePagination-toolbar":{
            minHeight:52,
            px:{xs:1,sm:2},
            flexWrap:{xs:"wrap",sm:"nowrap"},
            justifyContent:{xs:"center",sm:"flex-end"},
          },
          ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows":{
            fontSize:typography.sizes.sm,
          },
        }}
      />
    </Box>
  );
}